import { render, staticRenderFns } from "./EditableTree.vue?vue&type=template&id=fca63400&scoped=true"
import script from "./EditableTree.vue?vue&type=script&lang=js"
export * from "./EditableTree.vue?vue&type=script&lang=js"
import style0 from "./EditableTree.vue?vue&type=style&index=0&id=fca63400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca63400",
  null
  
)

export default component.exports